module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-2ed5115c8431e21d7b3833b850ee9ced.png";